import { requester } from "App";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import categorySound from "resources/music/물방울.mp3";
import btnSound from "resources/music/button-pressed-38129.mp3";
import SlideGuide from "../process/SlideGuide";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { useSelector } from "react-redux";
import HorizontalMenuButtons from "../../process/Button/HorizontalMenuButtons";
import HorizontalBrandList from "../../process/brand/HorizontalBrandList";
import HorizontalProductListView from "../HorizontalProductListView";




function HorizontalMainView2(props) {
    const { id } = useParams();
    const { viewData, setViewData, rankedProducts, showButtons, currentPage, setCurrentPage, setShowButtons, products, filteredProducts, setFilteredProducts, selectedCategory, setSelectedCategory, currentProductIndex, setCurrentProductIndex } = props;
    const navigate = useNavigate();
    const audioRef = useRef();
    const audio1Ref = useRef();
    const { isMobile } = useContext(BrowserDetectContext);
    const itemsPerPage = 10;
    const brandsItemsPerPage = 6;
    const [currentBrandPage, setCurrentBrandPage] = useState(1);
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState(brands);
    const [showBrandProducts, setShowBrandProducts] = useState(false);
    const [showExhibition, setShowExhibition] = useState(false);
    const [brandVisible, setBrandVisible] = useState(false);
    const [shouldShowSkeleton, setShouldShowSkeleton] = useState(false);
    const [shouldShowBrandSkeleton, setShouldShowBrandSkeleton] = useState(false);

    // 로딩 타이머 레퍼런스 추가
    const loadingTimerRef = useRef(null);
    const brandLoadingTimerRef = useRef(null);

    // 최소 스켈레톤 표시 시간 (밀리초)
    const MIN_SKELETON_TIME = 300;

    const { isLoading, isBrandLoading } = useSelector((state) => ({
        isLoading: state.history.isLoading,
        isBrandLoading: state.history.isBrandLoading
    }));

    // 스켈레톤 아이템 생성 함수들
    const createSkeletonItems = (count = 10) =>
        Array.from({ length: count }).map((_, index) => ({
            type: 'skeleton',
            key: `skeleton-${index}`
        }));

    const createSkeletonBrandItems = (count = 6) =>
        Array.from({ length: count }).map((_, index) => ({
            type: 'skeleton',
            key: `skeleton-brand-${index}`
        }));

    const totalProducts = filteredProducts.length;
    const totalPages = Math.ceil(totalProducts / itemsPerPage);
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);

    const brandTypeMap = {
        DISPOSABLEDEVICE: '일회용',
        DEVICE: '기기',
        LIQUID: '액상',
        null: '기타',
    };
    const uniqueBrandTypes = [...new Set(brands.map(brand => brand.brandType))].filter(type => type !== null);
    const productCategories = uniqueBrandTypes.map(type => brandTypeMap[type] || type);

    // 상품 데이터 로딩 처리 함수 - 타이머 기반 접근법
    const handleProductLoading = (loadingStartTime, apiCallback) => {
        // 1. 즉시 스켈레톤 상태 설정 (보이지는 않음)
        clearTimeout(loadingTimerRef.current);

        // 2. 타이머 설정 - 짧은 지연 후 스켈레톤 표시
        loadingTimerRef.current = setTimeout(() => {
            setShouldShowSkeleton(true);
        }, 100); // 짧은 지연 후 스켈레톤 표시 (빠른 응답에는 표시 안함)

        // 3. API 호출 및 응답 처리
        return (result) => {
            // API 응답 시간 계산
            const responseTime = Date.now() - loadingStartTime;

            // 응답이 빠르게 왔으면 스켈레톤 타이머 취소
            if (responseTime < MIN_SKELETON_TIME) {
                clearTimeout(loadingTimerRef.current);
                setShouldShowSkeleton(false);
            } else {
                // 충분히 시간이 지났으면 실제 데이터로 교체
            }

            // 원래 콜백 실행
            apiCallback(result);

            // 로딩 상태 해제
            dispatch(HistoryReducer.actions.setLoading(false));
        };
    };

    // 브랜드 데이터 로딩 처리 함수
    const handleBrandLoading = (loadingStartTime, apiCallback) => {
        // 스켈레톤 상태 설정
        clearTimeout(brandLoadingTimerRef.current);

        brandLoadingTimerRef.current = setTimeout(() => {
            setShouldShowBrandSkeleton(true);
        }, 100);

        return (result) => {
            const responseTime = Date.now() - loadingStartTime;

            if (responseTime < MIN_SKELETON_TIME) {
                clearTimeout(brandLoadingTimerRef.current);
                setShouldShowBrandSkeleton(false);
            }

            apiCallback(result);
            dispatch(HistoryReducer.actions.setBrandLoading(false));
        };
    };

    const onEventClick = () => {
        audioRef.current.play();

        // 1. 먼저 로딩 상태로 설정
        dispatch(HistoryReducer.actions.setLoading(true));

        setFilteredProducts([]);

        // 2. 즉시 UI 상태 업데이트
        setViewData((prevData) => ({
            ...prevData,
            view: "eventsProducts"
        }));

        // 3. 즉시 스켈레톤 데이터 설정
        setFilteredProducts(createSkeletonItems());

        // 4. 기타 UI 상태 설정
        setShowButtons(false);
        setShowExhibition(false);
        setBrands([]);
        setCurrentPage(1);

        // 5. 로딩 시작 시간 기록
        const loadingStartTime = Date.now();

        // 6. API 호출
        let data = { storeCode: id };
        requester.findEventProductsByStoreId(data, handleProductLoading(
            loadingStartTime,
            (result) => {
                if (result.code === 0) {
                    const eventProducts = result.data;
                    const eventProductIds = rankedProducts.map(product => product.id);
                    const filteredProducts = eventProducts.filter(product => !eventProductIds.includes(product.id));
                    const addProducts = [...rankedProducts, ...filteredProducts];
                    setFilteredProducts(addProducts);
                } else {
                    setFilteredProducts([]);
                }
            }
        ));
    };

    const onNewClick = () => {
        audioRef.current.play();

        // 1. 로딩 상태 설정
        dispatch(HistoryReducer.actions.setLoading(true));

        setFilteredProducts([]);

        // 2. 즉시 UI 상태 업데이트
        setViewData((prevData) => ({
            ...prevData,
            view: "newProducts"
        }));

        // 3. 즉시 스켈레톤 데이터 설정
        setFilteredProducts(createSkeletonItems());

        // 4. 기타 UI 상태 설정
        setShowButtons(false);
        setShowExhibition(false);
        setBrands([]);
        setCurrentPage(1);

        // 5. 로딩 시작 시간 기록
        const loadingStartTime = Date.now();

        // 6. API 호출
        let data = { storeCode: id };
        requester.findNewProductsByStoreId(data, handleProductLoading(
            loadingStartTime,
            (result) => {
                if (result.code === 0) {
                    console.log("findNewProductsByStoreId : ", result.data);
                    const newProducts = result.data;
                    const newProductIds = rankedProducts.map(product => product.id);
                    const filteredProducts = newProducts.filter(product => !newProductIds.includes(product.id));
                    const addProducts = [...rankedProducts, ...filteredProducts];
                    setFilteredProducts(addProducts);
                } else {
                    setFilteredProducts([]);
                }
            }
        ));
    };

    const onBestClick = () => {
        audioRef.current.play();

        // 1. 로딩 상태 설정
        dispatch(HistoryReducer.actions.setLoading(true));

        setFilteredProducts([]);

        // 2. 즉시 UI 상태 업데이트
        setViewData((prevData) => ({
            ...prevData,
            view: "bestProducts"
        }));

        // 3. 즉시 스켈레톤 데이터 설정
        setFilteredProducts(createSkeletonItems());

        // 4. 기타 UI 상태 설정
        setShowButtons(false);
        setShowExhibition(false);
        setBrands([]);
        setCurrentPage(1);

        // 5. 로딩 시작 시간 기록
        const loadingStartTime = Date.now();

        // 6. API 호출
        let data = { storeCode: id };
        requester.getBestProducts(data, handleProductLoading(
            loadingStartTime,
            (result) => {
                if (result.code === 0) {
                    const bestProducts = result.data;
                    const bestProductIds = rankedProducts.map(product => product.id);
                    const filteredProducts = bestProducts.filter(product => !bestProductIds.includes(product.id));
                    const addProducts = [...rankedProducts, ...filteredProducts];
                    setFilteredProducts(addProducts);
                } else {
                    setFilteredProducts([]);
                }
            }
        ));
    };

    const onBrandClick = () => {
        audioRef.current.play();

        // 1. 로딩 상태 설정
        dispatch(HistoryReducer.actions.setBrandLoading(true));

        setFilteredProducts([]);

        // 2. 즉시 UI 상태 업데이트
        setViewData((prevData) => ({
            ...prevData,
            view: "brandList"
        }));

        // 3. 즉시 스켈레톤 데이터 설정
        setFilteredBrands(createSkeletonBrandItems());
        setBrands(createSkeletonBrandItems());

        // 4. 기타 UI 상태 설정
        setShowButtons(false);
        setShowBrandProducts(true);
        setFilteredProducts([]);

        // 5. 로딩 시작 시간 기록
        const loadingStartTime = Date.now();

        // 6. API 호출
        let data = { storeCode: id };
        requester.findBrandsByStoreCode(data, handleBrandLoading(
            loadingStartTime,
            (result) => {
                if (result.data) {
                    setBrands(result.data);
                    setFilteredBrands(result.data);
                } else {
                    setBrands([]);
                    setFilteredBrands([]);
                }
            }
        ));
    };

    const onExhibitionClick = () => {
        setShowButtons(false);
        setShowExhibition(true);
        setShowBrandProducts(false);
    };

    const onAdClick = () => {
        audioRef.current.play();

        // 1. 로딩 상태 설정
        dispatch(HistoryReducer.actions.setLoading(true));

        setFilteredProducts([]);

        // 2. 즉시 UI 상태 업데이트
        setViewData((prevData) => ({
            ...prevData,
            view: "adProducts"
        }));

        // 3. 즉시 스켈레톤 데이터 설정
        setFilteredProducts(createSkeletonItems());

        // 4. 기타 UI 상태 설정
        setShowButtons(false);
        setBrandVisible(true);
        setBrands([]);
        setShowBrandProducts(false);
        setCurrentPage(1);

        // 5. 로딩 시작 시간 기록
        const loadingStartTime = Date.now();

        // 6. API 호출
        let brandData = {
            storeCode: id,
            brandId: "c836e67e-8f92-474c-88e8-39240974378a"
        };
        requester.findAllProductsByBrand(brandData, handleProductLoading(
            loadingStartTime,
            (result) => {
                setFilteredProducts(result.data);
            }
        ));
    };

    const onGoBackBtnClick = () => {
        audioRef.current.play();
        let data = { storeCode: id };

        if (selectedCategory === 'main') {
            if (viewData.view === "BrandProductList") {
                setBrandVisible(false);
                dispatch(HistoryReducer.actions.setBrandLoading(true));

                // 즉시 UI 상태 업데이트
                setViewData((prevData) => ({
                    ...prevData,
                    view: "brandList",
                    currentBrandPage: null
                }));

                // 즉시 스켈레톤 데이터 설정
                setFilteredBrands(createSkeletonBrandItems());
                setBrands(createSkeletonBrandItems());

                // 로딩 시작 시간 기록
                const loadingStartTime = Date.now();

                requester.findBrandsByStoreCode(data, handleBrandLoading(
                    loadingStartTime,
                    (result) => {
                        setShowBrandProducts(true);
                        setBrands(result.data);
                        setFilteredBrands(result.data);
                    }
                ));

                setCurrentPage(1);
            } else if (viewData.view === "brandList") {
                setBrands([]);
                setShowButtons(true);
                setViewData((prevData) => ({
                    ...prevData,
                    view: "main",
                }));
                setCurrentPage(1);
                setCurrentBrandPage(1);
            } else {
                setShowButtons(true);
                setViewData((prevData) => ({
                    ...prevData,
                    view: null,
                }));
                setCurrentPage(1);
            }
        } else {
            dispatch(HistoryReducer.actions.setBrandLoading(true));

            // 즉시 스켈레톤 데이터 설정
            setFilteredBrands(createSkeletonBrandItems());
            setBrands(createSkeletonBrandItems());

            // 로딩 시작 시간 기록
            const loadingStartTime = Date.now();

            requester.findBrandsByStoreCode(data, handleBrandLoading(
                loadingStartTime,
                (result) => {
                    setShowBrandProducts(true);
                    setBrands(result.data);
                    setFilteredBrands(result.data);
                }
            ));

            setCurrentPage(1);
        }
    };

    useEffect(() => {
        if (brands.length === 0 && viewData.view === "brandList") {
            let data = { storeCode: id };
            dispatch(HistoryReducer.actions.setBrandLoading(true));

            // 즉시 스켈레톤 데이터 설정
            setFilteredBrands(createSkeletonBrandItems());
            setBrands(createSkeletonBrandItems());

            // 로딩 시작 시간 기록
            const loadingStartTime = Date.now();

            requester.findBrandsByStoreCode(data, handleBrandLoading(
                loadingStartTime,
                (result) => {
                    setShowBrandProducts(true);
                    setBrands(result.data);
                    setFilteredBrands(result.data);
                }
            ));
        }
    }, [brands]);

    useEffect(() => {
        if (totalPages === 0 && currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [totalPages, currentPage]);

    useEffect(() => {
        if ((viewData.view === "brandList" && brands.length > 0) || (viewData.view !== "brandList" && filteredProducts.length > 0)) {
            const timer = setTimeout(() => {
                setViewData((prevData) => ({
                    ...prevData,
                    slideGuide: false
                }));
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [showBrandProducts, brands, filteredProducts]);

    // 컴포넌트 언마운트 시 타이머 정리
    useEffect(() => {
        return () => {
            clearTimeout(loadingTimerRef.current);
            clearTimeout(brandLoadingTimerRef.current);
        };
    }, []);

    return (
        <div style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex", alignItems: "center" }}>
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <audio ref={audio1Ref} src={btnSound} preload="auto" />
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {brands.length > 0 && viewData.slideGuide &&
                    <div style={{ position: "absolute", top: "40%", left: "40%", width: "max-content", zIndex: 999 }}>
                        <SlideGuide setViewData={setViewData} />
                    </div>
                }
                {viewData.slideGuide && filteredProducts.length > 0 &&
                    <div style={{ position: "absolute", top: "40%", left: "40%", width: "max-content", zIndex: 999 }}>
                        <SlideGuide setViewData={setViewData} />
                    </div>
                }
                {
                    (viewData.view === null || viewData.view === undefined || viewData.view === 'main') && (viewData.view !== "adProducts" || viewData.view !== "bestProducts" || viewData.view !== "newProducts" || viewData.view !== "eventsProducts" || viewData.view !== "BrandProductList" || viewData.view !== "brandList") ?
                        <HorizontalMenuButtons
                            onBrandClick={onBrandClick}
                            onAdClick={onAdClick}
                            onEventClick={onEventClick}
                            onBestClick={onBestClick}
                            onNewClick={onNewClick}
                        />
                        : viewData.view === "brandList" ? (
                            <HorizontalBrandList
                                brands={brands}
                                setBrands={setBrands}
                                filteredBrands={filteredBrands}
                                setFilteredBrands={setFilteredBrands}
                                brandVisible={brandVisible}
                                setShowExhibition={setShowExhibition}
                                setBrandVisible={setBrandVisible}
                                setShowBrandProducts={setShowBrandProducts}
                                setFilteredProducts={setFilteredProducts}
                                setViewData={setViewData}
                                currentBrandPage={currentBrandPage}
                                setCurrentBrandPage={setCurrentBrandPage}
                                onGoBackBtnClick={onGoBackBtnClick}
                                isLoading={isBrandLoading}
                                shouldShowSkeleton={shouldShowBrandSkeleton}
                            />
                        )
                            :
                            (viewData.view === "adProducts" || viewData.view === "bestProducts" || viewData.view === "eventsProducts" || viewData.view === "newProducts" || viewData.view === "BrandProductList" || viewData.view === "detail") ?
                                <HorizontalProductListView
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    filteredProducts={filteredProducts}
                                    setViewData={setViewData}
                                    onGoBackBtnClick={onGoBackBtnClick}
                                    currentProductIndex={currentProductIndex}
                                    setCurrentProductIndex={setCurrentProductIndex}
                                    isLoading={isLoading}
                                    shouldShowSkeleton={shouldShowSkeleton}
                                />
                                :
                                <p>상품을 불러오는 중 오류가 발생했습니다.</p>
                }
            </div>
        </div>
    );
}

export default HorizontalMainView2;